import sortBy from 'lodash/sortBy';
import Resources from '../../../helpers/resources';
import DateParamHelper from '../../../helpers/date-param-helper';
import errorActions from '../../app/errors/errors-actions';
import { ENDPOINT_PATH_ACTIVITY_MASTERY } from '../../../helpers/constants';
import { useLokalise } from '../../../helpers/locale-helpers';

export const ACTIVITY_MASTERY_CLASS_RETRIEVED =
    'ACTIVITY_MASTERY_CLASS_RETRIEVED';

function getActivityMasteryData(classroomId, selectedDateFilter) {
    return (dispatch) =>
        Resources.singleClassReport
            .get({
                reportType: ENDPOINT_PATH_ACTIVITY_MASTERY,
                ...DateParamHelper.getDateTypePath(selectedDateFilter),
                classroomId
            })
            .withParams(DateParamHelper.getDateQueryParams(selectedDateFilter))
            .send()
            .then((payload) => {
                if (payload.valid) {
                    dispatch({
                        type: ACTIVITY_MASTERY_CLASS_RETRIEVED,
                        payload: mapActivityMasteryData(payload.data)
                    });
                } else {
                    dispatch(
                        errorActions.addError(ACTIVITY_MASTERY_CLASS_RETRIEVED)
                    );
                }
            });
}

function mapActivityMasteryData(data) {
    const {
        name,
        teachers,
        totalGoldBars: goldBars,
        totalActivities,
        classScoreBand: scoreBand,
        groupActivityMastery
    } = data;

    let teacherName = '';
    const { teacherNumTitle } = useLokalise();
    if (teachers) {
        if (teachers.length > 1) {
            teacherName = teacherNumTitle(teachers.length);
        } else {
            teacherName = teachers[0].teacherName;
        }
    }

    const activityMastery = {
        goldBars,
        totalActivities,
        scoreBand,
        groupActivityMastery: groupActivityMastery.map((group) => ({
            id: group.id,
            name: group.name,
            courseName: group.courseName,
            totalActivities: group.totalActivities,
            scoreBand: group.scoreBand,
            goldBars: group.goldBars,
            students: sortBy(
                group.students.map((student) => ({
                    ...student,
                    id: student.userProfileId,
                    fullName: `${student.lastName}, ${student.firstName}`
                })),
                ['lastName', 'firstName']
            ),
            strengths: {
                topics: mapStrengthWeakness(group.topicStrengths),
                activities: mapStrengthWeakness(group.activityStrengths)
            },
            weaknesses: {
                topics: mapStrengthWeakness(group.topicWeaknesses, false),
                activities: mapStrengthWeakness(group.activityWeaknesses, false)
            }
        }))
    };

    const strengths = {
        topics: mapStrengthWeakness(data.topicStrengths),
        activities: mapStrengthWeakness(data.activityStrengths)
    };
    const weaknesses = {
        topics: mapStrengthWeakness(data.topicWeaknesses, false),
        activities: mapStrengthWeakness(data.activityWeaknesses, false)
    };

    return {
        name,
        teacherName,
        activityMastery,
        strengths,
        weaknesses
    };
}

function mapStrengthWeakness(strengthWeakness, descending = true) {
    const defaultData = {
        id: 0,
        title: '-',
        averageResult: '- '
    };

    if (!strengthWeakness.length) {
        return [defaultData];
    }

    let sorted;
    if (descending) {
        sorted = strengthWeakness.sort(
            (a, b) => a.averageResult < b.averageResult
        );
    } else {
        sorted = strengthWeakness.sort(
            (a, b) => a.averageResult > b.averageResult
        );
    }

    return sorted.map((data, idx) => ({
        ...data,
        id: idx
    }));
}

export default {
    getActivityMasteryData
};



// WEBPACK FOOTER //
// ./containers/activity-mastery/single-class/single-class-actions.js